import React from 'react'
import { Collapse } from 'antd'
import constants from '../../../constants'

const GlossaryPage: React.FC = () => (
	<div className='div-content' style={{ paddingLeft: '4rem' }}>
		<br />
		<h2>Glosario de términos</h2>
		<br />
		<Collapse
			accordion
			bordered={false}
			style={{ marginRight: '2rem', marginBottom: '2rem', borderRadius: '5px' }}
		>
			{constants.glossary
				.sort((a, b) => a.word.localeCompare(b.word))
				.map(({ word, definition, image }) => (
					<Collapse.Panel
						key={word}
						header={word}
						style={{ borderRadius: '5px', borderBottom: '0' }}
					>
						<img src={image} alt='' width='150px' />
						<p>{definition}</p>
					</Collapse.Panel>
				))}
		</Collapse>
	</div>
)

export default GlossaryPage
